export interface UserProfileModel {
  name?: string;
  displayName: string;
  pairings: Partial<ProductModel>[];
}

export interface ProductModel {
  code: ProductCodes;
  name: string;
  learnMoreUrl: string;
  domain?: string;
  loginUrl?: string;
  userid?: string;
  pathParam: string;
  queryParam: string;
}

export enum ProductCodes {
  AL = 'AL',
  HE = 'HE',
  PS = 'PS',
  TR = 'TR',
}

export const Products: Record<ProductCodes, ProductModel> = {
  [ProductCodes.AL]: {
    code: ProductCodes.AL,
    name: 'Alice',
    learnMoreUrl: 'https://actabl.com/alice/',
    pathParam: '/authentication/authenticate-with-unifiedlogin/',
    queryParam: 'token=',
  },
  [ProductCodes.HE]: {
    code: ProductCodes.HE,
    name: 'Hotel Effectiveness',
    learnMoreUrl: 'https://actabl.com/hotel-effectiveness/',
    pathParam: '',
    queryParam: 'token=',
  },
  [ProductCodes.PS]: {
    code: ProductCodes.PS,
    name: 'ProfitSword',
    learnMoreUrl: 'https://actabl.com/profitsword/',
    pathParam: '',
    queryParam: 'upt=',
  },
  [ProductCodes.TR]: {
    code: ProductCodes.TR,
    name: 'Transcendent',
    learnMoreUrl: 'https://actabl.com/transcendent/',
    pathParam: '',
    queryParam: 'upt=',
  },
};

export interface CreateUserModel {
  username: string;
  email: string;
  displayName: string;
  password: string;
  confirmPassword: string;
  agreeToTerms: boolean;
}

export const ActablProductNames = {
  actabl: 'Actabl',
  alice: Products['AL'].name,
  hotelEffectiveness: Products['HE'].name,
  profitSword: Products['PS'].name,
  transcendent: Products['TR'].name,
};

export interface MfaUserProfileModel {
  twoFactorEnabled: boolean;
  twoFactorDelay: boolean;
  twoFactorType: TwoFactorTypes;
  originProduct: MfaOriginProductModel;
}

export interface MfaOriginProductModel {
  code: ProductCodes | 'UP';
  userid?: string;
  email?: string;
  loginUrl?: string;
}

export enum TwoFactorTypes {
  EMAIL = 'email',
  TOTP = 'totp',
  NONE = 'none',
}
